import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSearchMembersMutation } from '../../../../../features/authentication/assignApiSlice';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';
import CustomToast from '../../../../../components/Toast';
import { useAssignmentContext } from '../../../context';
import AddCollaborators from '../../AddCollaborators';

const baseUrl = appConfig.apiBaseUrl;
const AddCollaboratorsModal = ({ modalData, setModalData, setCoteacherModel, setUpdatedCoTeachers, fromMoreActions }) => {
  const token = useSelector(selectCurrentToken);
  const [searchAllMembers] = useSearchMembersMutation();
  const [searchValue, setSearchValue] = useState('');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [coTeacherSelectedList, setCoTeacherSelectedList] = useState([]);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCoTeacherList, setSelectedCoTeacherList] = useState([]);

  const { assignmentId, setAssignmentId, assignedData, setAssignedData, setAssignedDataStatus } =
    useAssignmentContext();

  const searchMembersAsync = async (text) => {
    try {
      const options = {
        searchText: text.trim()
      };
      const searchMembersResponse = await searchAllMembers(options).unwrap();
      setSelectedMembers(searchMembersResponse); //All selected coteachers
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };

  const removeAllHandler = () => {
    const membersSelected = selectedMembers.map((item) => ({ ...item, isSelected: false }));
    setCoTeacherSelectedList([]);
    setSelectedMembers(membersSelected);
    setSelectedCoTeacherList([]);
    setIsEnabled(false);
  };

  const addCoTeacherAsync = async () => {
    const coTeacherData = selectedCoTeacherList.map((item) => ({
      teacherId: item.studentId,
      allowEdit: true
    }));
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentIds:
            !fromMoreActions
              ? assignedData.map((item) => item.assignmentId)
              : [assignmentId],
          teacherData: coTeacherData
        };
        let url = baseUrl + '/Assignment/AddCoTeacher';
        if (options.assignmentIds && options.assignmentIds.length > 0) {
          options.assignmentIds.map(
            (item, index) =>
            (url += `${index === 0 ? '?' : ''}assignmentIds=${item}${options.assignmentIds.length !== index + 1 ? '&' : ''
              }`)
          );
        }
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const addCoTeacherResponse = await fetch(url, {
          headers,
          method: 'POST',
          body: JSON.stringify(options.teacherData)
        });
        const result = addCoTeacherResponse.status;
        if (result === 200) {
          CustomToast('Collaborators added successfully ', 'success');
          if (setCoteacherModel != undefined)
            setCoteacherModel(false);
          setIsLoading(false);
          removeAllHandler();
        } else {
          CustomToast('Unable to update collaborators', 'error');
          setIsLoading(false);
          setCoteacherModel(false);
        }
        removeAllHandler();
        setSearchValue('');
        setSelectedMembers([]);
        setModalData(false);
        setAssignedData([]);
        setAssignmentId[''];
        setAssignedDataStatus(new Date().getSeconds());
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    }
  };
  return (
    <AddCollaborators
      isOpen={modalData}
      onClose={setModalData}
      title={'Add Assignment Collaborators'}
      addBoxTitle={'Collaborators'}
      helpTooltip={true}
      searchData={searchMembersAsync}
      selectedMembers={selectedMembers}
      setSelectedMembers={setSelectedMembers}
      teacherList={coTeacherSelectedList}
      setTeacherList={setCoTeacherSelectedList}
      teacherDataUpdate={selectedCoTeacherList}
      setTeacherDataUpdate={setSelectedCoTeacherList}
      removeAll={removeAllHandler}
      updateCoTeacher={addCoTeacherAsync}
      isLoading={isLoading}
      isEnabled={isEnabled}
      setIsEnabled={setIsEnabled}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      setUpdatedCoTeachersList={setUpdatedCoTeachers}
      fromMoreActions={fromMoreActions}
    />
  );
};

AddCollaboratorsModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  setCoteacherModel: PropTypes.func,
  setUpdatedCoTeachers: PropTypes.func,
  fromMoreActions: PropTypes.bool
};

export default AddCollaboratorsModal;
